import { StyleSheet } from "@react-pdf/renderer";

const colors = {
    white: "#FFFFFF",
    black: "#000000",
    primaryText: "#1F2937",
    mutedText: "#6B7280",
    accent: "#4F7BD9",
    primary: "#4F7BD9",
    link: "#2563EB",
    border: "#E5E7EB",
    borderDark: "#E5E7EB",
    sectionHeaderBg: "#4F7BD9",
    rowAlt: "#F6F8FC",
    kvHeaderBg: "#FFFFFF",
    kvTitleBg: "#FFFFFF",
    successBg: "#E9F7EF",
    unavailableBg: "#F1F3F5",
};

const FONT = {
    body: 10,
    small: 9,
    caption: 8,
    subtitle: 12,
    title: 15,
    coverTitle: 25,
    coverCompany: 19,
};

const styles = StyleSheet.create({
    page: {
        backgroundColor: colors.white,
        fontSize: FONT.body,
        position: "relative",
        fontFamily: "Open Sans",
        paddingBottom: 30,
    },
    page1: {
        backgroundColor: colors.white,
        fontSize: FONT.body,
        position: "relative",
        fontFamily: "Open Sans",
        paddingBottom: 30,
    },
    content: {
        paddingHorizontal: 30,
        paddingTop: 16,
    },
    sectionBlock: {
        marginBottom: 16,
    },
    sectionTitle: {
        width: "100%",
        fontWeight: 700,
        fontSize: FONT.title,
        color: colors.primary,
        paddingBottom: 6,
        marginBottom: 16,
        marginTop: 12,
        borderBottomWidth: 1,
        borderBottomColor: colors.primary,
        borderBottomStyle: "solid",
    },
    subSectionTitle: {
        fontSize: FONT.subtitle,
        fontWeight: 700,
        color: colors.primary,
        marginBottom: 10,
        marginTop: 14,
    },
    wordSectionContent: {
        paddingHorizontal: 24,
        paddingTop: 12,
    },
    wordOverviewLabel: {
        fontSize: FONT.subtitle,
        fontWeight: 700,
        color: colors.primary,
        marginBottom: 8,
    },
    wordOverviewBody: {
        fontSize: FONT.body,
        color: colors.primaryText,
        marginBottom: 12,
        lineHeight: 1.5,
    },
    wordTableHeaderCell: {
        backgroundColor: colors.primary,
        borderRightWidth: 0,
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    wordTableHeaderText: {
        color: colors.white,
        textAlign: "left",
        fontSize: FONT.body,
        fontWeight: 700,
        width: "100%",
        lineHeight: 1.45,
        paddingBottom: 2,
    },
    tocContent: {
        paddingHorizontal: 24,
        paddingTop: 12,
    },
    tocHeading: {
        width: "100%",
        fontWeight: 700,
        fontSize: FONT.title,
        color: colors.primaryText,
        marginBottom: 4,
    },
    tocSubtitle: {
        fontSize: FONT.small,
        color: colors.mutedText,
        marginBottom: 10,
    },
    tocTable: {
        width: "100%",
        borderWidth: 1,
        borderColor: colors.border,
        borderStyle: "solid",
        borderRadius: 6,
        overflow: "hidden",
    },
    tocHeaderRow: {
        flexDirection: "row",
        backgroundColor: colors.primary,
        paddingVertical: 5,
        paddingHorizontal: 10,
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
        overflow: "hidden",
    },
    tocHeaderSection: {
        flexGrow: 1,
        fontSize: FONT.body,
        fontWeight: 700,
        color: colors.white,
        textAlign: "left",
    },
    tocHeaderPage: {
        width: 40,
        fontSize: FONT.body,
        fontWeight: 700,
        color: colors.white,
        textAlign: "right",
    },
    tocRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        paddingVertical: 3,
        paddingHorizontal: 10,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderBottomStyle: "solid",
        backgroundColor: colors.white,
    },
    tocRowAlt: {
        backgroundColor: colors.rowAlt,
    },
    tocChildRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        paddingVertical: 2,
        paddingHorizontal: 10,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderBottomStyle: "solid",
        backgroundColor: colors.white,
    },
    tocLabel: {
        flexGrow: 1,
        flexShrink: 1,
        fontSize: FONT.body,
        fontWeight: 600,
        color: colors.primaryText,
        paddingRight: 8,
    },
    tocChildLabel: {
        flexGrow: 1,
        flexShrink: 1,
        fontSize: FONT.small,
        fontWeight: 400,
        color: colors.primaryText,
        paddingLeft: 14,
        paddingRight: 8,
    },
    tocPage: {
        width: 36,
        flexShrink: 0,
        fontSize: FONT.body,
        fontWeight: 600,
        color: colors.primaryText,
        textAlign: "right",
    },
    tocChildPage: {
        width: 36,
        flexShrink: 0,
        fontSize: FONT.small,
        fontWeight: 600,
        color: colors.primaryText,
        textAlign: "right",
    },
    tocLastRow: {
        borderBottomWidth: 0,
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6,
        overflow: "hidden",
    },
    kvTable: {
        display: "table",
        width: "100%",
        marginBottom: 12,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: colors.border,
        borderRadius: 6,
        overflow: "hidden",
    },
    kvTableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderBottomStyle: "solid",
        backgroundColor: colors.white,
    },
    kvTableLastRow: {
        borderBottomWidth: 0,
    },
    kvTableTitleCol: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        backgroundColor: colors.white,
        borderRightWidth: 1,
        borderRightColor: colors.border,
        borderRightStyle: "solid",
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    kvTableDetailCol: {
        width: "60%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        backgroundColor: colors.white,
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    kvTableCell: {
        fontSize: FONT.body,
        color: colors.primaryText,
        width: "100%",
        textAlign: "left",
        lineHeight: 1.45,
        paddingBottom: 2,
    },
    kvTableKeyText: {
        fontWeight: 700,
        color: colors.primaryText,
    },
    kvTableDetailText: {
        fontWeight: 400,
        color: colors.primaryText,
    },
    metricGrid: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginBottom: 12,
    },
    metricItem: {
        width: "50%",
        paddingRight: 8,
        marginBottom: 10,
    },
    metricLabel: {
        fontSize: FONT.small,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    metricValue: {
        fontSize: FONT.body,
        color: colors.accent,
    },
    emptyStateText: {
        fontSize: FONT.body,
        color: colors.mutedText,
        fontStyle: "italic",
        marginBottom: 8,
    },
    coverContent: {
        flexGrow: 1,
        paddingHorizontal: 40,
        paddingTop: 28,
        paddingBottom: 36,
        display: "flex",
        flexDirection: "column",
    },
    coverPage: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
    },
    coverEyebrow: {
        fontSize: FONT.caption,
        fontWeight: 700,
        color: colors.primary,
        letterSpacing: 1.2,
        marginBottom: 10,
    },
    coverMainTitle: {
        fontSize: FONT.coverTitle,
        fontWeight: 700,
        color: colors.primaryText,
        marginBottom: 8,
    },
    coverMainSubtitle: {
        fontSize: FONT.body,
        color: colors.mutedText,
        marginBottom: 16,
    },
    coverAccentLine: {
        width: 72,
        height: 3,
        backgroundColor: colors.primary,
        marginBottom: 28,
    },
    coverCompanyName: {
        fontSize: FONT.coverCompany,
        fontWeight: 700,
        color: colors.primaryText,
        marginBottom: 6,
    },
    coverCompanySubtitle: {
        fontSize: FONT.body,
        color: colors.mutedText,
        marginBottom: 24,
    },
    coverMetaGrid: {
        width: "100%",
        borderWidth: 1,
        borderColor: colors.border,
        borderStyle: "solid",
        borderRadius: 8,
        overflow: "hidden",
        marginBottom: 24,
    },
    coverMetaRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderBottomStyle: "solid",
    },
    coverMetaRowLast: {
        borderBottomWidth: 0,
    },
    coverMetaCell: {
        width: "50%",
        paddingVertical: 12,
        paddingHorizontal: 14,
        backgroundColor: colors.rowAlt,
        borderRightWidth: 1,
        borderRightColor: colors.border,
        borderRightStyle: "solid",
    },
    coverMetaCellLast: {
        borderRightWidth: 0,
    },
    coverMetaCellAlt: {
        backgroundColor: colors.white,
    },
    coverMetaLabel: {
        fontSize: FONT.caption,
        fontWeight: 600,
        color: colors.mutedText,
        letterSpacing: 0.6,
        marginBottom: 4,
    },
    coverMetaValue: {
        fontSize: FONT.body,
        fontWeight: 400,
        color: colors.primaryText,
    },
    coverDisclaimer: {
        marginTop: "auto",
        backgroundColor: "#FDF2F2",
        borderWidth: 1,
        borderColor: "#F5C2C2",
        borderStyle: "solid",
        borderRadius: 6,
        paddingVertical: 10,
        paddingHorizontal: 12,
    },
    coverDisclaimerText: {
        fontSize: FONT.caption,
        color: colors.mutedText,
        lineHeight: 1.4,
    },
    coverFields: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 80,
        paddingBottom: 80,
        paddingLeft: 40,
        paddingRight: 40,
    },
    coverField: {
        marginBottom: 28,
        textAlign: "center",
        width: "100%",
    },
    coverLabel: {
        fontSize: FONT.subtitle,
        fontWeight: 600,
        marginBottom: 6,
        textAlign: "center",
    },
    coverValue: {
        fontSize: FONT.body,
        textAlign: "center",
    },
    ml1: {
        marginLeft: 4
    },
    section: {
        padding: '0px 50px',
        height: 'auto',
        flexGrow: 1
    },
    note: {
        fontSize: FONT.small,
        color: colors.primary,
        padding: '0px 35px',
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start'
    },
    generalInfosRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 12
    },
    generalInfosRowCol: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center'
    },
    generalInfosTitle: {
        fontWeight: 'bold'
    },
    generalInfosValue: {
        color: colors.primary,
        fontWeight: 'normal'
    },
    aiGeneralDescription: {
        lineHeight: 1.5
    },
    sections: {
        padding: "0px 30px",
    },
    sectionSeparator: {
        width: "100%",
        fontWeight: 700,
        fontSize: FONT.title,
        color: colors.primary,
        paddingBottom: 6,
        marginBottom: 16,
        marginTop: 12,
        borderBottomWidth: 1,
        borderBottomColor: colors.primary,
        borderBottomStyle: "solid",
    },
    generalInfos: {
        marginBottom: 20
    },
    table: {
        display: "table",
        width: "100%",
        marginBottom: 12,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: colors.border,
        borderRadius: 6,
        overflow: "hidden",
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        borderBottomStyle: "solid",
        backgroundColor: colors.white,
    },
    tableRowAlt: {
        backgroundColor: colors.rowAlt,
    },
    tableLastRow : {
        borderBottomWidth: 0,
    },
    tableColHeader: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        backgroundColor: colors.primary,
        borderRightWidth: 0,
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    fontBold: {
        fontWeight: "700"
    },
    tableCol: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        borderRightWidth: 0,
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    borderRightNone : {
        borderRightWidth: 0,
    },    
    tableCell: {
        fontSize: FONT.body,
        color: colors.primaryText,
        textAlign: "left",
        width: "100%",
        lineHeight: 1.45,
        paddingBottom: 2,
    },
    entityRecordsTable: {
        width: "100%",
        marginBottom: 12,
    },
    entityRecordsCell: {
        alignItems: "flex-start",
    },
    text: {
        fontSize: FONT.body,
        marginBottom: 10,
    },
    alphListItem: {
        color: colors.primary,
        fontSize: FONT.subtitle,
        fontWeight: 700,
        marginTop: 14,
        marginBottom: 10,
    },
    managementSummaryContent: {
        paddingHorizontal: 24,
        paddingTop: 8,
    },
    managementSummaryHeading: {
        fontSize: 11,
        fontWeight: 700,
        color: "#4F7BD9",
        letterSpacing: 0.8,
        marginBottom: 3,
    },
    managementSummaryUnderline: {
        width: 26,
        height: 2,
        backgroundColor: "#4F7BD9",
        marginBottom: 8,
    },
    managementSummaryBox: {
        backgroundColor: "#F8F9FB",
        borderWidth: 1,
        borderColor: "#ECEEF2",
        borderRadius: 10,
        paddingHorizontal: 8,
        paddingVertical: 8,
        marginBottom: 10,
    },
    summaryMetricsRow: {
        flexDirection: "row",
        alignItems: "center",
    },
    summaryMetricsRowDivider: {
        borderTopWidth: 1,
        borderTopColor: "#E6E8EE",
        marginTop: 8,
        paddingTop: 8,
    },
    summaryField: {
        flexGrow: 1,
        flexBasis: 0,
        flexDirection: "row",
        alignItems: "center",
        paddingRight: 4,
    },
    summaryFieldBody: {
        flexGrow: 1,
        flexShrink: 1,
    },
    summaryIconCircle: {
        width: 24,
        height: 24,
        borderRadius: 10,
        backgroundColor: "#FDECEE",
        alignItems: "center",
        justifyContent: "center",
        marginRight: 4,
    },
    summaryIcon: {
        width: 16,
        height: 16,
    },
    summaryFieldLabel: {
        fontSize: FONT.caption,
        color: "#9AA0A8",
        fontWeight: 600,
        marginBottom: 1,
        width: "100%",
    },
    summaryFieldValue: {
        fontSize: FONT.caption,
        fontWeight: 700,
        color: "#1F2937",
        width: "100%",
    },
    summaryStatusPill: {
        fontSize: 7,
        fontWeight: 700,
        paddingVertical: 2,
        paddingHorizontal: 6,
        borderRadius: 8,
        alignSelf: "flex-start",
    },
    progressRing: {
        width: 32,
        height: 32,
        position: "relative",
        marginLeft: 2,
    },
    progressRingSvg: {
        width: 32,
        height: 32,
    },
    progressRingText: {
        position: "absolute",
        top: 12,
        left: 0,
        width: 32,
        textAlign: "center",
        fontSize: 6,
        color: "#1F2937",
    },
    functionBadgesRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    functionBadge: {
        backgroundColor: "#59C94F",
        color: colors.white,
        fontSize: 7,
        fontWeight: 600,
        paddingVertical: 2,
        paddingHorizontal: 3,
        marginRight: 2,
        marginBottom: 2,
        textAlign: "center",
        minWidth: 16,
    },
    percentRing: {
        width: 34,
        height: 34,
        borderRadius: 17,
        borderWidth: 3,
        borderColor: colors.accent,
        alignItems: "center",
        justifyContent: "center",
    },
    percentRingText: {
        fontSize: FONT.caption,
        fontWeight: 600,
        color: colors.accent,
    },
    analyticsCards: {
        flexDirection: "row",
        marginBottom: 10,
    },
    analyticsCard: {
        flexGrow: 1,
        flexBasis: 0,
        borderWidth: 1,
        borderColor: "#E6E8EE",
        borderRadius: 8,
        paddingHorizontal: 8,
        paddingVertical: 8,
        marginRight: 6,
        backgroundColor: colors.white,
    },
    analyticsCardLast: {
        marginRight: 0,
    },
    analyticsTitle: {
        fontSize: 10,
        fontWeight: 700,
        color: "#1F2937",
        marginBottom: 8,
    },
    donutWrap: {
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 8,
        position: "relative",
        width: 104,
        height: 104,
        alignSelf: "center",
    },
    donutSvg: {
        width: 104,
        height: 104,
    },
    donutCenterValue: {
        position: "absolute",
        top: 46,
        left: 0,
        width: 104,
        fontSize: 9,
        fontWeight: 700,
        color: "#374151",
        textAlign: "center",
    },
    legendGrid: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    legendGridItem: {
        width: "50%",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 3,
    },
    taskCountRow: {
        flexDirection: "row",
        borderTopWidth: 1,
        borderTopColor: "#E6E8EE",
        marginTop: 6,
        paddingTop: 6,
    },
    taskCountItem: {
        flexGrow: 1,
        flexBasis: 0,
        alignItems: "center",
    },
    taskCountValue: {
        fontSize: 9,
        fontWeight: 700,
        marginBottom: 1,
    },
    taskCountLabel: {
        fontSize: 6,
        textAlign: "center",
    },
    legendRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    legendItemCompact: {
        flexDirection: "row",
        alignItems: "center",
        marginRight: 6,
        marginBottom: 3,
    },
    legendLabelCompact: {
        fontSize: 7,
        color: colors.mutedText,
    },
    legendItem: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 3,
    },
    legendDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        marginRight: 4,
    },
    legendLabel: {
        fontSize: FONT.caption,
        color: colors.primaryText,
        flexGrow: 1,
    },
    legendValue: {
        fontSize: FONT.caption,
        color: colors.mutedText,
    },
    activityItem: {
        marginBottom: 7,
    },
    activityRow: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    activityIcon: {
        width: 10,
        height: 10,
        marginTop: 1,
        marginRight: 3,
    },
    activityBody: {
        flexGrow: 1,
        flexShrink: 1,
    },
    activityDate: {
        fontSize: FONT.caption,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    activityText: {
        fontSize: FONT.caption,
        color: colors.mutedText,
    },
    riskMatrixTitle: {
        fontSize: FONT.subtitle,
        fontWeight: 700,
        color: colors.primary,
        marginTop: 14,
        marginBottom: 10,
    },
    riskMatrixTableWrap: {
        position: "relative",
    },
    riskMatrixTable: {
        borderWidth: 1,
        borderColor: colors.borderDark,
        marginTop: 2,
    },
    riskMatrixHeaderRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
    },
    riskMatrixRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
    },
    riskMatrixAxisLabelCell: {
        width: 38,
        minHeight: 24,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixAxisValueCell: {
        width: 38,
        minHeight: 24,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixBodyRow: {
        flexDirection: "row",
    },
    riskMatrixLikelihoodAxisLabelColumn: {
        width: 38,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
    },
    riskMatrixDataRows: {
        flexGrow: 1,
        flexDirection: "column",
    },
    riskMatrixYAxisCell: {
        width: 38,
        minHeight: 47,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        borderBottomWidth: 1,
        borderBottomColor: "#FFFFFF",
        backgroundColor: "#F0F1FF",
        justifyContent: "center",
        alignItems: "center",
    },
    riskMatrixConsequenceBand: {
        flexGrow: 1,
        minHeight: 24,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F0F1FF",
    },
    riskMatrixConsequenceText: {
        fontSize: FONT.caption,
        fontWeight: 600,
        color: colors.primaryText,
    },
    riskMatrixLikelihoodText: {
        position: "absolute",
        left: -78,
        width: 200,
        height: 30,
        fontSize: 7,
        color: colors.primaryText,
        textAlign: "center",
        fontWeight: 500,
        transform: "rotate(270deg)",
    },
    riskMatrixYAxisText: {
        fontSize: 7,
        textAlign: "center",
        fontWeight: 500,
    },
    riskMatrixXAxisCell: {
        flexGrow: 1,
        flexBasis: 0,
        minHeight: 18,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 1,
        backgroundColor: "#F0F1FF",
    },
    riskMatrixXAxisText: {
        fontSize: 6,
        textAlign: "center",
    },
    riskMatrixCell: {
        flexGrow: 1,
        flexBasis: 0,
        minHeight: 26,
        borderRightWidth: 1,
        borderRightColor: "#FFFFFF",
        justifyContent: "flex-end",
        paddingHorizontal: 3,
        paddingBottom: 2,
    },
    matrixRiskCellBottom: {
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
    },
    matrixBulletsWrap: {
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth: "78%",
    },
    matrixRiskBullet: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: "#828282",
        borderWidth: 1,
        borderColor: "#FFFFFF",
        marginRight: 2,
        marginBottom: 2,
    },
    matrixCountWrap: {
        flexDirection: "row",
        alignItems: "center",
    },
    riskMatrixCellText: {
        fontSize: 7,
        color: colors.white,
        fontWeight: 600,
    },
    riskRatingDot: {
        width: 8,
        height: 8,
        borderRadius: 4,
    },
    complianceTableWrap: {
        marginBottom: 12,
    },
    complianceGroupHeaderRow: {
        flexDirection: "row",
        marginBottom: 4,
    },
    complianceInputGroupHeader: {
        width: "78%",
        backgroundColor: "#FFDADA",
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderWidth: 1,
        borderColor: colors.borderDark,
    },
    complianceResultGroupHeader: {
        width: "22%",
        backgroundColor: "#E9E9EA",
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderWidth: 1,
        borderLeftWidth: 0,
        borderColor: colors.borderDark,
    },
    complianceGroupHeaderText: {
        fontSize: FONT.caption,
        fontWeight: 600,
        textAlign: "center",
        color: colors.primaryText,
    },
    complianceTable: {
        borderWidth: 1,
        borderColor: colors.borderDark,
        borderRadius: 6,
        overflow: "hidden",
    },
    complianceHeaderRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.borderDark,
    },
    complianceDataRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: colors.borderDark,
    },
    complianceInputGroup: {
        width: "78%",
        flexDirection: "row",
    },
    complianceResultGroup: {
        width: "22%",
        flexDirection: "row",
    },
    complianceSubRowSpacer: {
        width: "78%",
        backgroundColor: "#FFDADA",
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 18,
    },
    complianceHeaderCell: {
        flexGrow: 1,
        flexBasis: 0,
        justifyContent: "flex-start",
        paddingTop: 4,
        paddingBottom: 6,
        paddingHorizontal: 3,
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 22,
    },
    complianceInputHeaderCell: {
        backgroundColor: "#FFDADA",
    },
    complianceResultHeaderCell: {
        backgroundColor: "#E9E9EA",
    },
    complianceBodyCell: {
        flexGrow: 1,
        flexBasis: 0,
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "flex-start",
        paddingTop: 4,
        paddingBottom: 6,
        paddingHorizontal: 3,
        borderRightWidth: 1,
        borderRightColor: colors.borderDark,
        minHeight: 20,
    },
    complianceInputBodyCell: {
        backgroundColor: "#FFDADA",
    },
    complianceResultBodyCell: {
        backgroundColor: "#E9E9EA",
    },
    complianceHeaderText: {
        fontSize: 7,
        fontWeight: 600,
        textAlign: "center",
        color: colors.primaryText,
        width: "100%",
        lineHeight: 1.4,
        paddingBottom: 1,
    },
    complianceBodyText: {
        fontSize: 7,
        color: colors.primaryText,
        width: "100%",
        lineHeight: 1.4,
        paddingBottom: 1,
    },
    reportSummary: {
        borderWidth: 1,
        borderColor: colors.border,
        borderRadius: 6,
        overflow: "hidden",
        marginBottom: 10,
    },
    reportSummaryHeader: {
        backgroundColor: colors.primary,
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
        overflow: "hidden",
    },
    reportSummaryHeaderText: {
        color: colors.white,
        fontSize: FONT.body,
        fontWeight: 700,
    },
    reportSummaryRow: {
        flexDirection: "row",
    },
    reportSummaryCell: {
        width: "33.33%",
        paddingVertical: 8,
        paddingHorizontal: 10,
        borderRightWidth: 1,
        borderRightColor: colors.border,
    },
    reportSummaryCellLast: {
        borderRightWidth: 0,
        borderBottomRightRadius: 6,
        borderBottomLeftRadius: 0,
    },
    reportSummaryLabel: {
        fontSize: FONT.caption,
        color: colors.mutedText,
        marginBottom: 2,
    },
    reportSummaryValue: {
        fontSize: FONT.body,
        fontWeight: 400,
        color: colors.primaryText,
        width: "100%",
    },
    complianceEmptyRow: {
        width: "100%",
        borderWidth: 1,
        borderColor: colors.borderDark,
        paddingTop: 8,
        paddingBottom: 10,
        paddingHorizontal: 6,
    },
    complianceFindingsBlock: {
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: colors.borderDark,
        backgroundColor: "#F9FAFB",
        paddingVertical: 6,
        paddingHorizontal: 10,
        marginBottom: 2,
    },
    complianceFindingsTitle: {
        fontSize: FONT.small,
        fontWeight: 700,
        color: colors.primary,
        marginBottom: 4,
    },
    complianceFindingItem: {
        marginBottom: 4,
    },
    complianceFindingName: {
        fontSize: FONT.caption,
        fontWeight: 600,
        color: colors.primaryText,
        marginBottom: 2,
    },
    complianceFindingDescription: {
        fontSize: FONT.caption,
        color: colors.mutedText,
    },
});

export { colors, FONT };
export default styles;